import { Outlet, useLocation } from 'react-router-dom';
import { WregShell } from '@/components/webreg/WregShell';
import { WregDevPanel } from '@/components/webreg/WregDevPanel';
import { WregFlowProvider, useWregFlowActions } from '@/components/webreg/WregFlowProvider';
import { useWregNav } from '@/components/webreg/useWregNav';
import { useWregPromoEntry } from '@/components/webreg/useWregPromoEntry';
import { useWregDev } from '@/components/webreg/dev/WregDevContext';
import { WREG_SCENARIO_CODE, WREG_SCENARIO_END } from '@/components/webreg/wregScenarios';
import { WREG_STEP_NAME } from '@/components/webreg/wregSteps';
import { GO_TO_HOMEPAGE, SELECT_STEP_BACK } from '@/consts/events';
import { useAnalytics } from '@/hooks/useAnalytics';

const WregShellHost = () => {
  const location = useLocation();
  const { step, canBack, back } = useWregNav();
  const { helpOpen, helpSource, setHelpOpen } = useWregFlowActions();
  const promoReady = useWregPromoEntry();
  const { track } = useAnalytics();
  const stepName = WREG_STEP_NAME[step];

  const onBack = () => {
    track({ event: SELECT_STEP_BACK, properties: { step_name: stepName } });
    back();
  };

  const onHome = () => {
    track({ event: GO_TO_HOMEPAGE, properties: { step_name: stepName }, beacon: true });
  };

  return (
    <WregShell
      step={step}
      canBack={canBack}
      onBack={onBack}
      helpOpen={helpOpen}
      onHelpOpenChange={setHelpOpen}
      helpSource={helpSource}
      onHome={onHome}
    >
      {promoReady ? (
        <Outlet key={location.pathname} />
      ) : (
        <div className="rg-wait" role="status">
          <span className="rg-btn-dots" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
        </div>
      )}
    </WregShell>
  );
};

const WregDevPanelHost = () => {
  const dev = useWregDev();
  const { startOver, jumpToEnd } = useWregFlowActions();

  if (!dev.enabled) return null;

  return (
    <WregDevPanel
      scenario={dev.scenario}
      onScenario={(id) => {
        dev.setScenario(id);
        dev.setMockCode(WREG_SCENARIO_CODE[id]);
        startOver();
      }}
      code={dev.mockCode}
      onCode={(code) => {
        dev.setMockCode(code);
        startOver();
      }}
      live={dev.live}
      onLive={dev.setLive}
      disclosure={dev.disclosure}
      onDisclosure={dev.setDisclosure}
      onEnd={(id) => {
        dev.setScenario(id);
        dev.setMockCode(WREG_SCENARIO_CODE[id]);
        const target = WREG_SCENARIO_END[id];
        if (target) jumpToEnd(target);
      }}
    />
  );
};

const WregLayout = () => (
  <WregFlowProvider>
    <WregShellHost />
    <WregDevPanelHost />
  </WregFlowProvider>
);

export { WregLayout };
